import {RootState} from "../store";

export const getBunsInConstructor = (state: RootState) => state.ingredientsInConstructor.bunsInConstructor;
export const getMainAndSauceInConstructor = (state: RootState) => state.ingredientsInConstructor.mainAndSauceInConstructor;
export const getTotalBuns = (state: RootState) => state.ingredientsInConstructor.totalBuns;
export const getTotalMainAndSauce = (state: RootState) => state.ingredientsInConstructor.totalMainAndSauce;
export const getOrderButtonEnabled = (state: RootState) => state.ingredientsInConstructor.isOrderButtonEnabled;